//
// Copyright (c) 2021 Astute Global, Inc.
//

import { Plugin } from "ckeditor5";
import CustomTemplateEditing from "./customTemplateEditing";
import CustomTemplateUi from "./customTemplateUi";

export default class CustomTemplate extends Plugin {
  // noinspection JSUnusedGlobalSymbols
  static get requires() {
    return [CustomTemplateEditing, CustomTemplateUi];
  }

  // noinspection JSUnusedGlobalSymbols
  static get pluginName() {
    return "CustomTemplate";
  }
}
